import { z } from 'zod';
export const occupationsByGroupIdsParamsSchema = z.string().uuid().array();
